import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Radio } from 'lucide-react';

/**
 * STEP 8-I-4 · Return-to-LIVE CTA — Cart · Checkout · Order Complete 상단에서 재사용.
 *
 * Buyer 가 LIVE 방송 중 상품을 담거나 주문하러 이동한 경우
 * `sessionStorage['livemoa:return_to_live']` 에 `/live-view/{session_id}` 가 저장돼 있다.
 * 이 컴포넌트는 값이 있을 때만 렌더 · 클릭 시 그 URL 로 navigate.
 *
 * 신규 route/API 0건 · 기존 LiveKitViewer 재사용.
 * clearOnClick=true 를 주면 클릭 시 return-to-live 값을 소비(제거).
 */
const ReturnToLiveButton = ({ label = '방송으로 돌아가기', clearOnClick = false, className = '' }) => {
  const navigate = useNavigate();
  const [href, setHref] = useState(null);

  useEffect(() => {
    try {
      const v = sessionStorage.getItem('livemoa:return_to_live');
      if (v) setHref(v);
    } catch { /* ignore */ }
  }, []);

  if (!href) return null;

  const onClick = () => {
    if (clearOnClick) {
      try { sessionStorage.removeItem('livemoa:return_to_live'); } catch {}
    }
    navigate(href);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="return-to-live-cta"
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-[#FF3B30] hover:bg-[#D32F2F] text-white text-xs font-black shadow-sm ${className}`}
    >
      <Radio size={12} className="animate-pulse" />
      🔴 {label}
    </button>
  );
};

export default ReturnToLiveButton;
